import { BellElectric, BotMessageSquare, CheckCheck, ChevronDown, CopyPlus, CornerDownRight, CornerLeftDown, CornerLeftUp, LayoutGrid, ListChecks, Minus, MoveLeft, MoveRight, Pencil, Play, Plus, StepBack, StepForward, Trash2, X } from "lucide-react";
import React, { useEffect, useState,useRef } from "react";
import fallback_img from "../img/fallback_img.jpg"
import loading_img from "../img/loadingImg.jpg"
import ScrollTransformWrapper from "../../DesignElements/hook/ScrollTransformWrapper";

import TrimmedTextUI from "./TrimmedTextUI";
import YoutubeDefaultPlayer from "../../VideoPlayer/YoutubeDefaultPlayer";
import VimeoDefaultPlayer from "../../VideoPlayer/VimeoDefaultPlayer";
import UniversalVideoPlayer from "../../VideoPlayer/UniversalVideoPlayerWebUI";
import VimeoVideoPlayerWebUI from "../../VideoPlayer/VimeoVideoPlayerWebUI";
import YoutubeVideoPlayerWebUI from "../../VideoPlayer/YoutubeVideoPlayerWebUI";
import * as Cards from "../../Cards";
// import * as Cards  from "@/components/Cards"
const   T1SectionCard1 = ({ setCurrentContentIndex,currentIndex,
  CurrentObject ,
  setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{
   


 const [relativeTop, setRelativeTop] = useState(0);
 const [scrollProgress, setScrollProgress] = useState(0);
 const [isVisible, setIsVisible] = useState(true);
 const [currentVideo, setCurrentVideo] = useState("");
 
 const [videoPopUp, setVideoPopUp] = useState(false);
               let  myStyles=   {
 circleL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 circleR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 squareL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 squareR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 rectangleHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rectangleHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
       
          goUp:{transform:relativeTop? ` translateY(${(relativeTop*3 )}px) `:''},
         goDown:{transform:relativeTop? ` translateY(${(-relativeTop*3 )}px) `:''},
         goLeft:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) `:''},
         goRight:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) `:''},
        
         zoomIn:{transform:relativeTop? `  scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
        zoomOut:{transform:relativeTop? `  scale(${(relativeTop>1?(relativeTop/100)*1:1 )}) `:''},
       
         skewVertical:{transform:relativeTop>0? ` rotateX(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewX(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
         skewHorizontal:{transform:relativeTop>0? ` rotateY(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewY(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
          
         flipVertical:{transform:relativeTop>0? `   rotateX(${(relativeTop<60?-relativeTop:0)}deg) `:''},
          flipHorizontal:{transform:relativeTop>0? `   rotateY(${(relativeTop<60?-relativeTop:0)}deg) `:''},
        spinLeft:{transform:relativeTop>0? `  rotateZ(${(relativeTop )}deg) `:''},
        spinRight:{transform:relativeTop>0? `  rotateZ(${(-relativeTop )}deg) `:''},
       
         slideUpZoom:{transform:relativeTop? ` translateY(${((relativeTop)*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideDownZoom:{transform:relativeTop? ` translateY(${((-relativeTop) )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideLeftZoom:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideRightZoom:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         
         slideUpSkew:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        slideDownSkew:{transform:relativeTop>0? `  translateY(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideLeftSkew:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideRightSkew:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        
        slideUpRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
        slideDownRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(-relativeTop )}deg) `:''},
        slideLeftRotate:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateZ(${((-relativeTop) )}deg) `:''},
        slideRightRotate:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
       
        slideUpFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
        slideDownFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(-relativeTop )}deg) `:''},
        slideLeftFlip:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateY(${((-relativeTop) )}deg) `:''},
        slideRightFlip:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
       
  
          
        }






 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
       const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];
  const imagesList1 = [
                   { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized ScheduleJoin Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                             { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                ];
                 const imagesList2 = [
                   { id: 1,hideImage: false, title: "1x1",subtitle: "Live Online Sessions", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Personalised",subtitle: "Result-Oriented Curriculum", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Performance",subtitle: "Opportunities to perform live", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 5,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"  },
                            ];
                const titleList1 = [
                   { id: 1,hideImage: false, title: "Only at ClasssMock!",subtitle: "Learn music & dance at your own pace through a personalized adaptive learning model that favors your interest and growth. Get a trusted result-oriented curriculum created by industry experts to accelerate your learning. You will also get multiple performance opportunities to boost your confidence and improve your technical skills.", image: "none" },
                       ];
  const  [cardObjectInn ,setCardObject] =useState(CurrentObject);
  
   const [isHovered, setIsHovered] = useState(false);
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`T1SectionCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`T1SectionCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`T1SectionCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`T1SectionCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};

const Image2FallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`T1SectionCard1-CardImage2-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`T1SectionCard1-CardImage2-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`T1SectionCard1-CardImage2-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`T1SectionCard1-CardImage2-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};

const FullWidthCarousel = ({ setCurrentVideo,setVideoPopUp,progressColor,images, itemOuter }) => {
  const containerRef = useRef(null);
  const [currentI, setCurrentI] = useState(0);
const totalSlides = images.length;
const [progress, setProgress] = useState(0); // from 0 to 100

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);
  }, 3000); // Change slide every 3 seconds

  return () => clearInterval(interval); // cleanup on unmount
}, [totalSlides]);
useEffect(() => {
  if(currentI<=totalSlides-1){scrollToSlide(currentI)}else{scrollToSlide(0)}
 
 
}, [currentI]);
  const scroll = (direction) => {
   if(currentI<=totalSlides-1){scrollToSlide(currentI);}else{scrollToSlide(0);}
 
  };
// Counter logic from 0 to 100 for each slide
useEffect(() => {
  setProgress(0); // reset when currentI changes

  const duration = 3000; // 3 seconds for full counter
  const stepTime = 30;   // update every 30ms
  const increment = 100 / (duration / stepTime); // e.g., ~1 per 30ms

  const counterInterval = setInterval(() => {
    setProgress((prev) => {
      const next = prev + increment;
      if (next >= 100) {
        clearInterval(counterInterval);
        return 100;
      }
      return next;
    });
  }, stepTime);

  return () => clearInterval(counterInterval); // cleanup
}, [currentI]);
  const scrollToSlide = (index) => {
    const container = containerRef.current;
    if (container) {
      const width = container.clientWidth;
      container.scrollTo({ left: width * index, behavior: "smooth" });
    
    }
  };

  return (
    <div className="carousel-wrapper"  >
      <div className="carousel-container" ref={containerRef}>
        {images.map((itemInner, index) => (
          <div className="carousel-slide" key={index}>
            

            { (
              <div
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  right: "0px",
                  zIndex: "99",
                }}
              >
{!itemInner?.hideVideo?<div style={{display:"flex",justifyContent:"center",}}>
      <div onClick={()=>{setCurrentVideo(index);setVideoPopUp(true) 
      }}   className={`playButtonOuter-T1SectionCard1-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],position:"absolute", alignItems:"center",cursor:"pointer"}} > 
      <div className={`playButtonInner-${itemOuter?.myKey}`} ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px"}}  color="#fff"/>
          </div></div>:""}
                <div  style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item6Animation?.type:""],position:"absolute",
                  left:itemOuter?.layoutSettings?.mirrorItems?.status?"20px":"",
                   right:itemOuter?.layoutSettings?.mirrorItems?.status?"":"20px ",top:"10%",zIndex:"999"}}>
           {!itemInner?.hideTitle?  <div className={`T1SectionCard1-cardRight-title-outer-${itemOuter?.myKey}`} style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item1Animation?.type:""],
             background:`${progressColor?.color10}`,padding:"5px 5px",paddingLeft:"15px",
            }}> 
            <div className={`T1SectionCard1-cardRight-title-${itemOuter?.myKey}  ${itemOuter?.layoutSettings?.titleEllipsis?.status?`T1SectionCard1-cardRight-title-ellipsis-${itemOuter?.myKey}`:``}`} 
              style={{
             
  
    fontSize: `${itemOuter?.layoutSettings?.typographyTitle?.size?.value}${itemOuter?.layoutSettings?.typographyTitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographyTitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographyTitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographyTitle?.textAlignment?.textAlign}`,
    textTransform: `${itemOuter?.layoutSettings?.typographyTitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographyTitle?.textStyle?.textStyle}`,
   textDecoration: `${itemOuter?.layoutSettings?.typographyTitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.resolution}`,
      lineHeight: `${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.resolution}`,
    letterSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.letterSpacing?.value}px`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.wordSpacing?.value}px`,
    
    WebkitTextStroke: `${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeSize?.value}px ${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeColor?.color}`,
   
     }}
       
          > {<TrimmedTextUI text={itemInner?.title} />}</div> </div>:""}
           {!itemInner?.hideSubtitle?
<div className={`T1SectionCard1-cardRight-title-outer-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item2Animation?.type:""],zIndex:"999",background:"#ffffff"}}>
          <div className={`T1SectionCard1-cardRight-description-${itemOuter?.myKey} 
            ${itemOuter?.layoutSettings.subtitleEllipsis?.status?`T1SectionCard1-cardRight-description-ellipsis-${itemOuter?.myKey}`:``}`}
              style={{ 
     padding:"5px 25px",marginTop:"20px",
    fontSize: `${itemOuter?.layoutSettings?.typographySubtitle?.size?.value}${itemOuter?.layoutSettings?.typographySubtitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographySubtitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographySubtitle?.textAlignment?.textAlign}`,
    textTransform:`${itemOuter?.layoutSettings?.typographySubtitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographySubtitle?.textStyle?.textStyle}`,
    textDecoration: `${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.resolution}`,
    lineHeight: ` ${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.resolution}`,
    letterSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.letterSpacing?.value}px`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.wordSpacing?.value}px`,
    WebkitTextStroke: ` ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.value}${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.resolution}  ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeColor?.color}`,
               }}
          
          > {<TrimmedTextUI text={itemInner?.subtitle} />}</div> 
</div>:""}

                </div> <div style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],}}>
              { !itemInner?.hideImage && <ImageFallFB  itemOuter={itemOuter}
                  boxShadow={``}
                  src={itemInner.image}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                   itemOuter?.layoutSettings.layoutAspectRatio?.value
                      ? itemOuter?.layoutSettings.layoutAspectRatio?.value
                      : 1
                  }
                  borderRadius={
                    itemOuter?.layoutSettings?.borderRadius1 || {
                      value: 30,
                      resolution: "%",
                    }
                  }
                />}</div>
              </div>
            )}
          </div>
        ))}

        {/* Buttons */}
        
      </div>

<div className={`carousel-SlideNo-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],background:`${itemOuter?.layoutSettings?.item1BG?.color}`}}>
  <h3><span style={{fontSize:"40px", fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,}}>{currentI+1}</span>/{totalSlides}</h3>
</div>
      {/* Dots */}
      <div className={`carousel-dots-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item5Animation?.type:""],background:`${itemOuter?.layoutSettings?.item2BG?.color}`}}>
  <div className="carousel-container-pagenation">
   <button className={`carousel-btn-${itemOuter?.myKey} left`} onClick={() => setCurrentI((prevIndex) => (prevIndex>0?prevIndex - 1:prevIndex) % totalSlides)}>
              <StepBack  size={30} color={"#333"} strokeWidth={1} />
            </button>
            <button className={`carousel-btn-${itemOuter?.myKey} right`} onClick={() => setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides)}>
              <StepForward size={30} color={"#333"}  strokeWidth={1} />
            </button>
  </div>

  {images
    .slice(
      Math.max(0, currentI - 1),
      Math.min(images?.length, currentI + 3)
    )
    .map((itemInner, i) => {
      const realIndex = Math.max(0, currentI - 1) + i;
      return ( !itemInner?.hideImage &&
        <div
          key={realIndex}
          className={`dot ${currentI === realIndex ? "active" : ""}`}
          onClick={() => setCurrentI(realIndex)}
        >
          <div
            className="circlekK"
            style={{  borderTopLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.topLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.topLeft?.resolution,borderBottomLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.resolution,borderTopRightRadius:itemOuter?.layoutSettings?.borderRadius3?.topRight?.value+itemOuter?.layoutSettings?.borderRadius3?.topRight?.resolution,borderBottomRightRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.resolution,            background:
                currentI === realIndex
                  ? `conic-gradient(${progressColor?.color10} 0% ${progress}%, black 0% 80%, transparent 80% 100%)`
                  : "",
            }}
          >
            <div className="circlekInnK">
              <Image2FallFB
                itemOuter={itemOuter}
                boxShadow={``}
                src={itemInner.image}
                border={``}
                width={
                  100
                }
                aspectRatio={1 / 1}
                borderRadius={
                  itemOuter?.layoutSettings?.borderRadius3 || {
                    value: 50,
                    resolution: "%",
                  }
                }
              />
            </div>
          </div>
        </div>
      );
    })}
</div>
    </div>
  );
};

return(<>
{}
  <ScrollTransformWrapper 
  setRelativeTop={(relativeTop)=>{setRelativeTop(relativeTop)}}
  setIsVisible={(isVisible)=>{setIsVisible(isVisible)}}
  setScrollProgress={(scrollProgress)=>{setScrollProgress(scrollProgress)}}
  containerId="scrollContainerId"
        maxTranslate={100}
        maxRotate={0}
        maxScale={1.1}
        customStyleFn={({ scale }) => ({
          myStyles:myStyles,
          transition: "transform 0.2s ease-in-out",
        })}
      >
        {/* {CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.youtube?.src} */}
       {!CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.hideVideo&&videoPopUp?<>
       <div     style={{zIndex:99,cursor:"pointer"}} onClick={()=>setVideoPopUp(false)} className={`videoPlayerPopUpBackDrop-${CurrentObject?.contents[1]?.myKey}`}> </div>
        <div   className={`videoPlayerPopUpMain-${CurrentObject?.contents[1]?.myKey}`} style={{height:"400px",borderRadius: '20px'}}> 
  <div style={{position:"relative"}}>
    <div  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"0px",margin:"10px",position:"absolute",
      background:`${CurrentObject?.contents[1]?.layoutSettings?.item1BG?.color}`,zIndex:99999999999999}} onClick={()=>{setVideoPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div>
    </div> 
       {CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.sourceType=="youtube"?
       !CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.youtube?.useDefaultPlayer?<YoutubeVideoPlayerWebUI videoSettings={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video} videoId={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.youtube?.src} minHeight={400} maxHeight={400}/>
       :<YoutubeDefaultPlayer videoSettings={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video}   videoId={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.youtube?.src} minHeight={400} maxHeight={400}/>
       :CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.sourceType=="vimeo"?
       !CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.vimeo?.useDefaultPlayer?<VimeoVideoPlayerWebUI  videoSettings={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video} videoId={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.vimeo?.src} minHeight={400} maxHeight={400}/>
       :<VimeoDefaultPlayer videoSettings={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video}   videoId={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.vimeo?.src} minHeight={400} maxHeight={400}/>
       :CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.sourceType=="mp4URL"?
       <UniversalVideoPlayer videoSettings={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video}   videoUrl={CurrentObject?.contents[1]?.itemCards?.cards[currentVideo]?.video?.mp4URL?.src} minHeight={400} maxHeight={400}/>:
       ""}
      
 </div>
       </>:""}
<div   className="hoverItemElementInner" 
      style={{
position:"relative",border:dynamicId==CurrentObject?.myKey?"2px solid rgba(144, 202, 249,1)":isHovered?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
          margin:"0px",marginTop:"25px",overflow:"hidden"}} >{}
           
    
                  
      <div className={`T1SectionCard1-card-${CurrentObject?.contents[1]?.myKey}`}>
      
        <div  className={`T1SectionCard1-card-BG${CurrentObject?.contents[1]?.myKey}`} ></div>
      
      
         {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
      
       {indexOuter==1?<>
      <div  className={isHovered?"":""}   style={{height:"50px",width:"100%",position:"absolute",top:"35px",left:"20px",zIndex:"999999",
  transform:"scale(1)"
}}>
 
       {dynamicId==itemOuter?.myKey? <div   style={{position:"absolute",top:"12px",left:"0px",fontSize:"12px",width:"280px",height:"25px",borderRadius:"5px",padding:"8px",border:"rgba(144, 202, 249,1)",background:"#ffffff"}}> <div style={{display:"flex",justifyContent:"space-between",}}>
            <div onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }} className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"40px",height:"15px",paddingRight:"5px"}}>  <CheckCheck size={12}  color="#333" /> Selected </div>
            <div onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo));moveItemDown(CurrentObject) }} className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"80px",height:"15px",paddingRight:"5px"}}> <CornerLeftDown size={12}  color="#333" /> Move Down </div>
            <div  onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo));moveItemUp(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"80px",height:"15px",paddingRight:"5px"}}> <CornerLeftUp size={12}  color="#333" /> Move Up </div>
            <div  onClick={()=>{;duplicateItem(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"center",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"20px",height:"15px",paddingRight:"5px"}}> <CopyPlus size={12}  color="#333" />  </div>
            <div  onClick={()=>{deleteItem(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"center",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"20px",height:"15px",paddingRight:"5px"}}> <Trash2 size={12}  color="#333" />  </div>
            </div>
            </div>:
        
          <div   style={{position:"absolute",top:"12px",left:"0px",fontSize:"12px",width:"280px",height:"25px",borderRadius:"5px",padding:"8px",border:"rgba(144, 202, 249,1)",background:"#ffffff"}}> <div style={{display:"flex",justifyContent:"space-between",}}>
            <div onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }} className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"40px",height:"15px",paddingRight:"5px"}}> <Pencil size={12}  color="#333" /> Edit </div>
             <div onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo));moveItemDown(CurrentObject) }} className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"80px",height:"15px",paddingRight:"5px"}}> <CornerLeftDown size={12}  color="#333" /> Move Down </div>
            <div  onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo));moveItemUp(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"80px",height:"15px",paddingRight:"5px"}}> <CornerLeftUp size={12}  color="#333" /> Move Up </div>
            <div  onClick={()=>{;duplicateItem(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"center",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"20px",height:"15px",paddingRight:"5px"}}> <CopyPlus size={12}  color="#333" />  </div>
            <div  onClick={()=>{deleteItem(CurrentObject) }}  className="ElementSettingsItem"  style={{display:"flex",justifyContent:"center",alignItems:"center",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"20px",height:"15px",paddingRight:"5px"}}> <Trash2 size={12}  color="#333" />  </div>
             </div>
            </div>}  
    
       
        </div>
        <div className={`T1SectionCard1-cardImages-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],
  transition: `transform 0.1s ease-in-out, opacity 0.5s ease`,
}}>  
      

             {/* <Cards.ItemsUI.CardAnim1 id={"uuidCA1"} mode={"white"} /> 
             <Cards.ItemsUI.CardAnim2 id={"uuidCA2"} mode={"white"}  />  */}
             
        </div></>:""}</>))}
        
     
     
      </div> <Cards.MobileCards.TwoMobilesUI />  
             <Cards.HeroCards.HeroCard1 />
             <Cards.HeroCards.HeroCard2 />
             <Cards.HeroCards.HeroCard3 />
             <Cards.HeroCards.HeroCard4 />
             <Cards.HeroCards.HeroCard5 />
             <Cards.HeroCards.HeroCard6 />
             <Cards.HeroCards.HeroCard7 />
             <Cards.HeroCards.HeroCard8 /> 
             <Cards.HeroCards.HeroCard9 />
             <Cards.HeroCards.HeroCard10 />
             <Cards.HeroCards.HeroCard11 /> 
             <Cards.HeroCards.HeroCard12 /> 
             <Cards.HeroCards.HeroCard13 /> 
             <Cards.HeroCards.HeroCard14 /> 
             <Cards.HeroCards.HeroCard15 /> 
             <Cards.HeroCards.HeroCard16 /> 
             <Cards.HeroCards.HeroCard17 /> 
             <Cards.HeroCards.HeroCard18 />
             <Cards.HeroCards.HeroCard19 />
             <Cards.HeroCards.HeroCard20 />
             <Cards.HeroCards.HeroCard21 />
             <Cards.HeroCards.HeroCard22 />
             <Cards.HeroCards.HeroCard23 />
             <Cards.HeroCards.HeroCard24 />
             <Cards.HeroCards.HeroCard25 />
             <Cards.HeroCards.HeroCard26 />
             <Cards.HeroCards.HeroCard27 />
             <Cards.HeroCards.HeroCard28 />
             <Cards.HeroCards.HeroCard29 />
             <Cards.HeroCards.HeroCard30 />
             <Cards.HeroCards.HeroCard31 />
             <Cards.HeroCards.HeroCard32 />
             <Cards.HeroCards.HeroCard33 />
             <Cards.FooterCards.FooterCard1 />
             <Cards.FooterCards.FooterCard2 />
             <Cards.FooterCards.FooterCard3 />
             <Cards.FooterCards.FooterCard4 />
             <Cards.FooterCards.FooterCard5 />
             <Cards.FooterCards.FooterCard6 />
             <Cards.FooterCards.FooterCard7 />
             <Cards.FooterCards.FooterCard8 />
             <Cards.FooterCards.FooterCard9 />
             <Cards.FooterCards.FooterCard10 />
             <Cards.FooterCards.FooterCard11 />
             <Cards.FooterCards.FooterCard12 />
             <Cards.FooterCards.FooterCard13 />
             <Cards.FooterCards.FooterCard14 />
             <Cards.FooterCards.FooterCard15 />
             <Cards.FooterCards.FooterCard16 />
             <Cards.AboutUsCards.AboutUsCard1 />
             <Cards.AboutUsCards.AboutUsCard2 />
             <Cards.AboutUsCards.AboutUsCard3 />
             <Cards.AboutUsCards.AboutUsCard4 />
             <Cards.AboutUsCards.AboutUsCard5 />
             <Cards.AboutUsCards.AboutUsCard6 />
             <Cards.AboutUsCards.AboutUsCard7 />
             <Cards.AboutUsCards.AboutUsCard8 />
             <Cards.AboutUsCards.AboutUsCard9 />
             <Cards.AboutUsCards.AboutUsCard10 />
             <Cards.AboutUsCards.AboutUsCard11 />
             <Cards.AboutUsCards.AboutUsCard12 />
             <Cards.AboutUsCards.AboutUsCard13 />
             <Cards.AboutUsCards.AboutUsCard14 />
             <Cards.CategoryCards.CategoryCard1 />
             <Cards.CategoryCards.CategoryCard2 />
             <Cards.CategoryCards.CategoryCard3 />
             <Cards.CategoryCards.CategoryCard4 />
             <Cards.CategoryCards.CategoryCard5 />
             <Cards.EventCards.EventCard1 />
             <Cards.EventCards.EventCard2 />
             <Cards.EventCards.EventCard3 />
             
             <Cards.TeamCards.TeamCard1 /> 
             <Cards.TeamCards.TeamCard2 />
             <Cards.TeamCards.TeamCard3 />
             <Cards.TeamCards.TeamCard4 />

             <Cards.CountDownCard.CountDownCard1 />
             <Cards.CountDownCard.CountDownCard2 />
             <Cards.CountDownCard.CountDownCard3 />
             <Cards.CountDownCard.CountDownCard4 />


             <Cards.CurriculumCard.CurriculumCard1 />
             
              </div></ScrollTransformWrapper>
      
      <style>{ CurrentObject?.contents?.map((item,index)=>(`
      .videoPlayerPopUpBackDrop-${item?.myKey}{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.661);
        z-index:99999999 !important}
        .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:15%;
    padding:15px;
    z-index:99999999 !important;}
.carousel-dots-${item?.myKey} {padding:10px;margin:10px; 
  border-top-left-radius:${item?.layoutSettings?.borderRadius3?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius3?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius3?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius3?.bottomRight?.value+"px"};
   
     border:${item?.layoutSettings?.item2Border?.borderWidth?.value}px ${item?.layoutSettings?.item2Border?.borderType} ${item?.layoutSettings?.item2Border?.borderColor?.color};
           box-shadow:${item?.layoutSettings?.item2Shadow?.horizontal?.value}px ${item?.layoutSettings?.item2Shadow?.vertical?.value}px ${item?.layoutSettings?.item2Shadow?.blur?.value}px ${item?.layoutSettings?.item2Shadow?.spread?.value}px ${item?.layoutSettings?.item2Shadow?.shadowColor?.color} ${item?.layoutSettings?.item2Shadow?.inset?"inset":""};
        
  text-align: center;
  width:340px;
  
  position:absolute;
  ${item?.layoutSettings?.mirrorItems?.status?"right:0px !important;":"left:0px !important;"}
  bottom:120px;z-index:999999!important;
  margin-top: 10px;
}.carousel-SlideNo-${item?.myKey} {padding:10px;margin:10px; border-radius:15px;
  text-align: center;width:50px;position:absolute;
  ${item?.layoutSettings?.mirrorItems?.status?"left:80px !important;":"right:80px !important;"}
 
  bottom:20px;z-index:999999!important;
  margin-top: 10px;
}

.circlekK {
    width: 80px;
    height: 80px;
    border-radius: 50%;
   
    display: flex;
    align-items: center;
    justify-content: center;
    position:relative;
  }
  .circlekInnK {
    position:absolute;
     height: 70px;
  width: 70px;
    border-radius: 50%;
    ;z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    
  }
    .circlekK.activek {
    background-color: rgb(86, 82, 131) ;
   
    border: 2px solid rgb(86, 82, 131);
    border-radius: 50%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  }
.dot {
  display: inline-block;
  height: 70px;
  width: 70px;
  margin: 5px 10px;
 
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.dot.active {
  background-color: #333;
}
    .carousel-wrapper {
  position: relative;
  
  width: 100%;
}

.carousel-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-slide {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
}

.carousel-slide img {
  width: 100%;
  height: auto;
  display: block;
}

.carousel-btn-${item?.myKey} {
  position: absolute;display:flex;justify-content:center;align-items:center;
  top: 35%; height:30px;width:30px;
 margin: 3px;border:2px solid #ffffffff;
       box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);border-radius: 5px;background: #ffffff;
  
  cursor: pointer;
  z-index: 999999;
}

.carousel-btn-${item?.myKey}.left {
  left: 10px;
}

.carousel-btn-${item?.myKey}.right {
  right: 10px;
}
.playButtonOuter-T1SectionCard1-${item?.myKey}{
 position: absolute;
    border:7px solid rgba(256, 256, 256, 0.50302); // Optional background for visibility
    color: white;z-index:999 !important;
    padding: 18px;background:${item?.layoutSettings?.item2BG?.color};
    border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
      width:${item?.layoutSettings.item1Width?.value?item?.layoutSettings.item1Width?.value:100}px;
            border:${item?.layoutSettings?.item1Border?.borderWidth?.value}px ${item?.layoutSettings?.item1Border?.borderType} ${item?.layoutSettings?.item1Border?.borderColor?.color};
           box-shadow:${item?.layoutSettings?.item1Shadow?.horizontal?.value}px ${item?.layoutSettings?.item1Shadow?.vertical?.value}px ${item?.layoutSettings?.item1Shadow?.blur?.value}px ${item?.layoutSettings?.item1Shadow?.spread?.value}px ${item?.layoutSettings?.item1Shadow?.shadowColor?.color} ${item?.layoutSettings?.item1Shadow?.inset?"inset":""};
            bottom:${item?.layoutSettings?.marginItem1?.marginBottom?.value}%;
              padding-top:${item?.layoutSettings?.paddingItem1?.paddingTop?.value}${item?.layoutSettings?.paddingItem1?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.paddingItem1?.paddingBottom?.value}${item?.layoutSettings?.paddingItem1?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.paddingItem1?.paddingLeft?.value}${item?.layoutSettings?.paddingItem1?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.paddingItem1?.paddingRight?.value}${item?.layoutSettings?.paddingItem1?.paddingRight?.resolution};
      
    height: 50px;
      }
.playButtonInner-${item?.myKey}{animation: PlayButtonAnim 2.8s infinite linear;
  border:7px solid rgba(256, 256, 256, 0.50302);
  z-index:999 !important;
  position: absolute;top:3px;left:0px;right:0px;bottom: 0px;
  padding: 18px;
   border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
   
  width: 35px; 
  height: 35px;}
@keyframes PlayButtonAnim{
  0% {
      /* opacity: 0; */
      transform: scale(1.4)
  }
  50% {
      transform: scale(0.81)
  }
 
  100% {
      transform: scale(1.4)
  }
  }
        .T1SectionCard1-card-${item?.myKey} {
          
            flex-direction:${item?.layoutSettings?.flexDirection};
         flex-wrap:${item?.layoutSettings?.flexWrap};
          
          justify-content:${item?.layoutSettings?.justifyContent};
         align-items:${item?.layoutSettings?.alignItems};
          margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.margin?.marginLeft?.value}${item?.layoutSettings?.margin?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.margin?.marginRight?.value}${item?.layoutSettings?.margin?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.padding?.paddingTop?.value}${item?.layoutSettings?.padding?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.padding?.paddingBottom?.value}${item?.layoutSettings?.padding?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.padding?.paddingLeft?.value}${item?.layoutSettings?.padding?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.padding?.paddingRight?.value}${item?.layoutSettings?.padding?.paddingRight?.resolution};
      
         
        
          
         
            
       border-top-left-radius:${item?.layoutSettings?.borderRadius1?.topLeft?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius1?.bottomLeft?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-top-right-radius:${item?.layoutSettings?.borderRadius1?.topRight?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius1?.bottomRight?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
   
     
          
        }
          .T1SectionCard1-card-BG${item?.myKey} {
           position:absolute;left:0px;right:0px;height:500px;top:0px;
        
        
         background:${item?.layoutSettings?.layoutBG?.color};
       
        }
          

          .T1SectionCard1-card-${item?.myKey}:hover {
         
         
         
        }
          .T1SectionCard1-cardImages-${item?.myKey} {
         
          
       border-top-left-radius:${item?.layoutSettings?.borderRadius1?.topLeft?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius1?.bottomLeft?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-top-right-radius:${item?.layoutSettings?.borderRadius1?.topRight?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius1?.bottomRight?.value+item?.layoutSettings?.borderRadius1?.topLeft?.resolution};
       width:${item?.layoutSettings?.layoutWidth?.value}%;
           border:${item?.layoutSettings?.layoutBorder?.borderWidth?.value}px ${item?.layoutSettings?.layoutBorder?.borderType} ${item?.layoutSettings?.layoutBorder?.borderColor?.color};
           box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};

         
 
        }
 

.T1SectionCard1-CardImage-wrapper${item?.myKey} {

position:absolute;z-index:99999;
width:95px;height:95px;
   
}
  
       
         
.T1SectionCard1-cardRight-title-${item?.myKey} {
        z-index:999;
        background: ${item?.layoutSettings?.typographyTitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
         
     white-space: ${item?.layoutSettings.titleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.titleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.titleEllipsis?.status?"ellipsis":"none"} ;;

   
        }

        .T1SectionCard1-cardRight-description-${item?.myKey} {
          font-size: 0.85rem;position:relative;z-index:999;
           background: ${item?.layoutSettings?.typographySubtitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
         
     white-space: ${item?.layoutSettings.subtitleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.subtitleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.subtitleEllipsis?.status?"ellipsis":"none"} ;;
   }
           .T1SectionCard1-cardRight-description-ellipsis-${item?.myKey} {
         white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      } .T1SectionCard1-cardRight-title-ellipsis-${item?.myKey} {
        
           white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      }

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .playButtonOuter-T1SectionCard1-${item?.myKey}{
 bottom:-100px !important;
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:10%;
                right:10%;top:100px;
               } 
 }
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
.T1SectionCard1-card-${item?.myKey} { flex-direction:column;}
  .T1SectionCard1-cardImages-${item?.myKey} { width:100%;margin:0px}
  .carousel-dots-${item?.myKey} { width:320px; bottom:0px; transform:scale(0.7)}
   .playButtonOuter-T1SectionCard1-${item?.myKey}{
 bottom:-100px !important;
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;
                left:10%;
                right:10%;top:100px;
               } 
  }
                                   /* xs */
@media (max-width: 767px) {
 .T1SectionCard1-card-${item?.myKey} { flex-direction:column; margin-bottom:150px !important}
  .T1SectionCard1-cardImages-${item?.myKey} { width:100%;margin:0px}
    .T1SectionCard1-CardImage-AspectRatioXs${item?.myKey} { aspect-ratio:2/3 !important;}
   .T1SectionCard1-CardImage2-AspectRatioXs${item?.myKey} { aspect-ratio:1/1 !important;}
   .T1SectionCard1-cardRight-title-outer-${item?.myKey}{ transform:scale(0.8);}
    .T1SectionCard1-cardRight-title-${item?.myKey} {line-height:30px  !important; ; ;top:32px,left:0px !important;right:0px !important;}
  .T1SectionCard1-cardRight-description-${item?.myKey} { font-size: 0.9rem !important;;width:100%;top:8px;}
  .T1SectionCard1-cardRight-title-${item?.myKey} {font-size: 1.8rem  !important; ;}
  .T1SectionCard1-card-BG${item?.myKey} {height:300px; }
  .carousel-dots-${item?.myKey} { width:320px; bottom:-20px; transform:scale(0.6)}

  .carousel-SlideNo-${item?.myKey} { border-radius:15px;transform:scale(0.6);
  left:75% !important;bottom:60px;
}
  .playButtonOuter-T1SectionCard1-${item?.myKey}{
 bottom:170px !important;transform:scale(0.6);
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:0%;
                right:0%;top:0px; bottom:0px!important;
               } 
}
 
      `))}</style>
  
</>)
}
export default T1SectionCard1;